import { createSlice } from "@reduxjs/toolkit";

export const LoginSlice = createSlice({
  name: "loginData",
  initialState: {
    auth: '',
    userInfo: {}
  },
  reducers: {
    saveAuthData: (state, action) => {
      state.auth = action.payload;
    },
    saveUserData: (state, action) => {
      state.userInfo = action.payload;
    }
  }
});

export const { saveAuthData, saveUserData } = LoginSlice.actions;
export default LoginSlice.reducer;